import React, { useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { validateAndGetGrantPageUrl, redirectToShopify } from '../../../store/actions/shopifyAppInstall';
import Spinner from '../../../components/common/Spinner';
import { useLocation } from 'react-router-dom';
import qs from 'querystringify';
import PageLayout from '../../../components/common/PageLayout/PageLayout';
import { ShopifySelectRetailer } from '../../../components/blocks/ShopifySelectRetailer/ShopifySelectRetailer';

export default function ShopifyAuthContainer() {
  const dispatch = useDispatch();
  const { redirectUrl } = useSelector((state) => state.shopify);

  const { retailers } = useSelector((state) => state.role.user);
  const [retailerId, setRetailerId] = useState(0);
  const [posting, setPosting] = useState(false);
  const location = useLocation();

  const noRetailers = useMemo(() => retailers.length === 0, [retailers]);
  const singleRetailer = useMemo(() => retailers.length === 1, [retailers]);

  useEffect(() => {
    if (!posting && location && (singleRetailer || retailerId)) {
      const queryParams = qs.parse(location.search);
      if (retailerId) {
        queryParams.retailerId = retailerId;
      }
      dispatch(validateAndGetGrantPageUrl(queryParams));
      setPosting(true);
    }
  }, [dispatch, posting, location, retailerId, singleRetailer]);

  useEffect(() => {
    if (redirectUrl) {
      redirectToShopify(redirectUrl);
    }
  }, [dispatch, redirectUrl]);

  return (
    <PageLayout>
      <div style={{ marginTop: '3em', textAlign: 'center' }}>
        <h2>Connecting your Shopify Account...</h2>
        {noRetailers ? (
          <h3 style={{ marginTop: '2em', lineHeight: 1.5 }}>
            You don't have any retailers connected to this account.
            <br />
            If there are any questions, please contact{' '}
            <a style={{ color: 'black' }} href="mailto:support@cym.bio">
              support@cym.bio
            </a>
            .
          </h3>
        ) : posting ? (
          <Spinner size="large" />
        ) : (
          <ShopifySelectRetailer onContinue={setRetailerId} />
        )}
      </div>
    </PageLayout>
  );
}
